/**
 * Stacking layers for overlays that leave the page flow.
 *
 * Every rounded card carries a `backdrop-filter`, which makes the card both a stacking context and
 * the containing block for any `position: fixed` descendant. An overlay rendered where it is
 * triggered is therefore trapped inside its card: its z-index only ranks it against that card's
 * own contents, so the next card down the page paints over it. Overlays escape by rendering
 * through `Portal`, which mounts them in `#portal`, outside `#root`; these values are what rank
 * them against the app once they are out there.
 */

// Full-screen flows that stand in for the whole app shell: the focused investment entry and Hey
// Nic's mobile sheet. They stay inside #root, so a portalled overlay has to clear them to show.
export const APP_SHELL_OVERLAY = 1200

// Menus and tooltips anchored to a control. Below modals, so a menu left open behind a dialog
// cannot cover it.
export const POPOVER = 1300

// Dialogs and the scrim they dim the page with.
export const MODAL = 1400
